import { jwtDecode } from 'jwt-decode';

let logoutTimer = null;

/**
 * Timeout登出
 */
export const forceLogout = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }

  localStorage.clear();
  window.location.href = '/';
};

/**
 * 設定 token 到期自動 logout
 * 登入成功後一定要呼叫
 */
export const setupAutoLogout = () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const { exp } = jwtDecode(token);

    // exp 是秒，JS Date 是毫秒
    const expireDate = new Date(exp * 1000);
    const expiresIn = exp * 1000 - Date.now();

    if (expiresIn <= 0) {
      forceLogout();
      return;
    }

    // 避免重複 timer
    if (logoutTimer) clearTimeout(logoutTimer);

    logoutTimer = setTimeout(() => {
      forceLogout();
    }, expiresIn);
  } catch (err) {
    forceLogout();
  }
};

/**
 * App 啟動時檢查 token（重新整理、重開瀏覽器）
 */
export const checkTokenOnInit = () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const { exp } = jwtDecode(token);
    if (Date.now() > exp * 1000) {
      forceLogout();
    } else {
      setupAutoLogout(); // 還沒過期，設定倒數
    }
  } catch {
    forceLogout();
  }
};

/**
 * 切回分頁時檢查（背景放很久）
 */
export const setupTokenFocusCheck = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;

    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const { exp } = jwtDecode(token);
      if (Date.now() > exp * 1000) {
        forceLogout();
      }
    } catch {
      forceLogout();
    }
  });
};
